import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import SubPageTemplate from "./templates/SubPageTemplate";
import Hidden from "@material-ui/core/Hidden";
import clsx from "clsx";
import Grid from "@material-ui/core/Grid";
import axios from "axios";
import { useTranslation } from 'react-i18next';
import InfiniteScroll from "react-infinite-scroller";
import Dropdown from "../components/inputs/Dropdown";
import {
  profileAPI,
  headerAPI,
  _link,
  numberWithCommas,
  CDN_URI,
  CDN_URI_BASE,
  handleMissingImg,
  prefixURI
} from "../common/utilities";
import styles from "./AchievementsPage.module.scss";
import missingAchievementImg from "../images/achievement-missing.png";

const achievementsPath = `${CDN_URI_BASE}web/achievements/`;

//keeps track of background-position-x to use for
//a given achievements progress where 'x_y' means
//achieved stage x out of y stages
const progressBarsImgMapping = {
  "0_1": "150px",
  "1_1": "75px",
  "0_3": "450px",
  "1_3": "375px",
  "2_3": "300px",
  "3_3": "225px",
  "0_5": "900px",
  "1_5": "825px",
  "2_5": "750px",
  "3_5": "675px",
  "4_5": "600px",
  "5_5": "525px"
};

//quickly done and not robust
const stripOff = filename => {
  let extensionStart = filename.lastIndexOf(".");
  let extension = filename.substring(extensionStart);
  let identifier = filename.substring(0, extensionStart);
  let newIdentifier = identifier.substring(0, identifier.indexOf("_off"));

  return newIdentifier + extension;
};

function AchievementItem({ data }) {
  let progress =
    data.CURRENT_STAGE != 0 ? `(${data.CURRENT_STAGE}/${data.Max})` : "";

  let name =
    data.CURRENT_STAGE > 0
      ? data[`Lvl_${data.CURRENT_STAGE}_Name`]
      : data.Display_Name;

  let content = (
    <div
      className={clsx(styles.item, data.CURRENT_STAGE == 0 && styles.disabled)}
    >
      <img
        src={`${achievementsPath}${stripOff(data.image_file)}`}
        onError={handleMissingImg(missingAchievementImg)}
        className={styles.image}
        style={{
          background:
            data.CURRENT_STAGE != 0
              ? `url(${CDN_URI}imgs/achievement_system/trophy_levels.gif)`
              : "",
          backgroundPositionX:
            progressBarsImgMapping[`${data.CURRENT_STAGE}_${data.Max}`]
        }}
      />
      <div className={styles.details}>
        <p className={styles.info}>
          <span className={styles.name}>{name}</span>
          <span
            className={styles.description}
          >{` ${progress} - ${data.Description}`}</span>
        </p>
        <p className={styles.rewards}>{`${data.Rewards}`}</p>
      </div>
    </div>
  );

  return (
    <Grid classes={{ root: styles.achievement_grid_item }} item md={6} sm={12}>
      {content}
    </Grid>
  );
}

export default function AcheivementsPage(props) {
  const { match, devUSN } = props;

  const { t, i18n } = useTranslation();

  const [headerData, setHeaderData] = useState();
  const [achievements, setAchievemnts] = useState([]);
  const [achievementsMappings, setAchievementsMappings] = useState([]);
  const [achievementPlayerCNT, setAchievementPlayerCNT] = useState();
  const [achievementCNT, setAchievementCNT] = useState();
  const [pageStatus, setPageStatus] = useState(true);

  const usn = devUSN ? devUSN : match ? match.params.usn : null;

  // Similar to componentDidMount and componentDidUpdate:
  //
  // https://stackoverflow.com/questions/53120972/how-to-call-loading-function-with-react-useeffect-only-once
  useEffect(() => {
    //api call to set data will be used
    if (usn) {
      axios.get(`${headerAPI}&usn=${usn}`).then(res => {
        if (res.data.p_o_ErrID === 1)
          setHeaderData(res.data.dsProfileHeaderInfo[0]);
        else setPageStatus(false);
      });

      axios
        .get(`${profileAPI}?usn=${usn}&command=achievements&achievement=0`)
        .then(res => {
          setAchievemnts(res.data.dsAchievementResult);
          setAchievementPlayerCNT(res.data.dsAchievementTotal[0].playerCNT);
          setAchievementCNT(res.data.dsAchievementTotal[0].achievementCNT);
        });

      axios.get(`${CDN_URI}js/achievement_system_data.json`).then(res => {
        setAchievementsMappings(res.data);
      });
    }
  }, []);

  if (achievements == null || achievementsMappings == null) {
    return null;
  }

  //make obj of achievemnts so it is easier to manipulate - move up
  //to useeffects when ready

  //obj of achievement mappings where keys are achievement ID
  let aObj = {};
  for (let item of achievementsMappings) {
    aObj[`${item.achievementID}`] = item;
  }

  let content = achievements.map(item => {
    return aObj.hasOwnProperty(`${item.MAIN_INDEX}`) ? (
      <AchievementItem
        data={{
          ...aObj[`${item.MAIN_INDEX}`],
          CURRENT_STAGE: item.CURRENT_STAGE
        }}
      />
    ) : null;
  });

  return (
    <SubPageTemplate
      title={t(
        'Achievement of {{ign}} - Crossfire Player Profile', 
        headerData ? headerData.NICK : "")}
      headerData={headerData}
      headingLeft={t('Achievements')}
      // userTotal={achievementTotal}
      // headingRight={`${ribbonsPlayerCount}/${ribbonsTotal}`}
      headingRight={
        achievementCNT ? `${achievementPlayerCNT}/${achievementCNT}` : ""
      }
      //headingRight={achievementCNT?`${achievementPlayerCNT}/${achievementCNT}`:""}
      // headingRight={`${numberWithCommas(inventoryTotalCount)} Items`}
    >
      <div className={styles.page_content_container}>
        {!pageStatus ? <Redirect to={`${prefixURI}/error`} /> : null}
        <Grid 
          container
          spacing={2} 
          classes={{ root: styles.page_content }}
        >
          {content}
        </Grid>
        <p className={styles.disclaimer}>
          {t('Data displayed is updated every 24 hours.')}
        </p>
      </div>
    </SubPageTemplate>
  );
}
